// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Login from "./pages/LoginPage";
import GetStartedPage from "./pages/GetStarted";
import PrivateRoute from "./components/PrivateRoute";
import TransactionPage from "./pages/TransactionPage";
import MainLayout from "./layout/MainLayout";
import { Navigate } from "react-router-dom";
import ProfilePage from "./pages/ProfilePage";
import TransactionsPage from "./pages/TransactionsPage";
import AiPage from "./pages/AiPage"
import { TransactionProvider } from './context/TransactionContext';
import { auth } from './config/firebase-config';

function App() {
  useEffect(() => {
    // Set up token refresh
    const unsubscribe = auth.onIdTokenChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        localStorage.setItem('idToken', token);
      } else {
        localStorage.removeItem('idToken');
      }
    });

    // Clean up subscription
    return () => unsubscribe();
  }, []);

  return (
   <TransactionProvider>
    {<Router>
      <Routes>
      <Route path="/" element={<Navigate to="/get-started" />} />

      <Route path="/get-started" element={<GetStartedPage/>} />
      <Route path="/login" element={<Login />} />
      <Route path="/ai" element={<PrivateRoute>  <AiPage/> </PrivateRoute> } />

      <Route path='/' element={<MainLayout/>}>
      
      <Route path="/home" element={ <PrivateRoute><HomePage /></PrivateRoute>   }/>
      <Route path="/transaction" element={<PrivateRoute> <TransactionPage/> </PrivateRoute> }/>
      <Route path="/profile" element={<PrivateRoute>  <ProfilePage/> </PrivateRoute> } />
      <Route path="/transactions" element={<PrivateRoute>  <TransactionsPage/> </PrivateRoute> } />



      </Route>
     
      </Routes>
    </Router>}
    </TransactionProvider>
  );
}




export default App;
